module.exports = __webpack_public_path__ + "img/nature8.c0d4cd64.jpg";